export enum SelectHeaderCheckboxTypes {
  Invoice_Inquiry_Select = 'InvoiceInquiry',
  Ticket_Inquiry_Select = 'TicketInquiry',
  Flag_Invoice_Select = 'FlagInvoice',
  Batch_Edit_Ticket_Select = 'BatchEditTicket'
}
